/* @flow */
import Activity, { ACTIVITY_PRINTED_MSG } from 'entities/Activity';
import ActivityActions from 'payments/actions/ActivityActions';
import ActivityShareModal from 'payments/components/ActivityShareModal.jsx';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Menu from 'components/Menu.jsx';
import MenuItem from 'components/MenuItem.jsx';
import { mountModal } from 'lib/modal';
import React from 'react';
import ToastActions from 'actions/ToastActions';
import LayerTrigger from 'components/LayerTrigger.jsx';

type Props = {
  activity: Activity,
  children?: any,
};

class ActivityActionMenuTrigger extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  renderShareModal = () => {
    mountModal(<ActivityShareModal activity={this.props.activity} />, this);
  }

  viewConversationClicked = () => {
    this.context.router.push(`/classes/r/messages/${this.props.activity.getChatUuid() || ''}`);
  }

  closeActivityClicked = () => {
    mountModal(
      <ConfirmDialog
        eventScreenName="ActivityActionMenuTrigger"
        size="xsmall"
        title={'Close this activity?'}
        subtext={`Once your activity is closed, participants won’t
        be able to send you money. You can still
        deposit funds to your bank account.`}
        actionButtonText="Close"
        cancelButtonText="Cancel"
        onConfirm={() => {
          ActivityActions.close(this.props.activity).then(
            () => ToastActions.showSuccessToast('Activity is now closed'),
            () => ToastActions.showDefaultErrorToast(),
          );
        }}
      />, this);
  }

  viewDetailsClicked = () => {
    this.context.router.push(`/activities/${this.props.activity.id}`);
  }

  printActivity = () => {
    Activity.export(this.props.activity.id)
      .then(
        () => ToastActions.showSuccessToast(ACTIVITY_PRINTED_MSG),
        () => ToastActions.showDefaultErrorToast()
      );
  }

  render() {
    const { activity } = this.props;

    const menu = (
      <Menu>
        <MenuItem onClick={this.renderShareModal}>
          Share
        </MenuItem>
        <MenuItem onClick={this.viewConversationClicked}>
          View conversation
        </MenuItem>
        {activity.isSender() && !activity.isClosed() &&
          <MenuItem onClick={this.closeActivityClicked}>
            Close activity
          </MenuItem>
        }
        {activity.isSender() &&
          <MenuItem onClick={this.viewDetailsClicked}>
            View details
          </MenuItem>
        }
        {activity.isSender() &&
          <MenuItem onClick={this.printActivity}>
            Print Activity
          </MenuItem>
        }
      </Menu>
    );

    return (
      <LayerTrigger
        layer={menu}
        trigger="click"
        alignment="right"
        placement="bottom">
        {this.props.children}
      </LayerTrigger>
    );
  }
}

export default ActivityActionMenuTrigger;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityActionMenuTrigger.jsx